import { CALL_API } from '../middleware/api'
import posthog from 'posthog-js'

export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const REFRESH_TOKEN_REQUEST = 'REFRESH_TOKEN_REQUEST'
export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS'
export const REFRESH_TOKEN_FAILURE = 'REFRESH_TOKEN_FAILURE'

export function loginUser(creds) {
  const { email, password } = creds

  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'authenticate/jwt/',
      authenticated: false,
      data: { email, password },
      types: [LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE]
    }
  }
}

export function refreshToken() {
  const refresh = localStorage.getItem('refreshToken')
  console.log('🔄 Action: refreshToken dispatched')

  if (!refresh) {
    console.error('❌ No refresh token found in localStorage')
    return {
      type: REFRESH_TOKEN_FAILURE,
      errors: { detail: 'No refresh token available' }
    }
  }

  return {
    [CALL_API]: {
      method: 'POST',
      endpoint: 'authenticate/jwt/refresh/',
      authenticated: false,
      data: { refresh },
      types: [
        REFRESH_TOKEN_REQUEST,
        REFRESH_TOKEN_SUCCESS,
        REFRESH_TOKEN_FAILURE
      ]
    }
  }
}

export function logoutUser() {
  return dispatch => {
    dispatch({ type: LOGOUT_REQUEST })

    // Limpiar tokens y datos de sesión
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('adminId')
    localStorage.removeItem('permissions')
    localStorage.removeItem('groups')
    localStorage.removeItem('cities')
    // Resto de la casilla «Recordarme», retirada en URBWEB-4349: se borra por
    // si quedó escrita en el navegador de alguien.
    localStorage.removeItem('rememberMe')

    posthog.reset()
    dispatch({ type: LOGOUT_SUCCESS })
  }
}
